import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classnames from 'classnames';

import TypesSlide from '../TypesSlide';
import * as Utils from '../../utils';

const TypesSlider = ({ isActive, items, nextArticle, title }) => {
  items = items?.map((item) => {
    return {
      ...item,
      is_open: false,
    };
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slides, setSlides] = useState(items || []);
  const hasSlides = !!slides.length;
  const typesSliderRef = useRef();
  const sliderRef = useRef();
  const settings = {
    infinite: false,
    appendDots: (dots) => {
      return (
        <div>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <ul className='types-slider__nav-list'>
                  {dots.map((item, index) => {
                    const isActive = !!item.props.className;
                    return (
                      <li
                        key={`types-slider__nav-list-item-${index}`}
                        className={classnames('types-slider__nav-list-item', {
                          'types-slider__nav-list-item--active': isActive,
                        })}
                      >
                        {item.props.children}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      );
    },
    arrows: false,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
    customPaging: (i) => {
      return (
        <button
          className='types-slider__nav-cta'
          dangerouslySetInnerHTML={{ __html: items?.[i]?.title }}
        />
      );
    },
    dots: true,
    dotsClass: 'types-slider__nav',
    draggable: false,
    swipe: false,
  };
  const scroll = (title) => {
    Utils.scroll(Utils.slugify(title));
  };
  const closeArticles = () => {
    const slidesComputed = slides.map((item) => {
      item.is_open = false;
      return item;
    });
    setSlides(slidesComputed);
  };
  const handleNextArticle = (index) => {
    sliderRef.current.slickGoTo(index + 1);
    scroll(title);
  };
  const handleNextSection = () => {
    closeArticles();
    scroll(nextArticle.title);
  };
  const handleToggle = (index) => {
    const slidesComputed = slides.map((item, itemIndex) => {
      if (itemIndex === index) {
        item.is_open = !item.is_open;
      }

      return item;
    });

    setSlides(slidesComputed);
  };
  const handleCloseArticle = (index) => {
    handleToggle(index);
    scroll(title);
  };

  if (!hasSlides) {
    return null;
  }

  return (
    <div
      className={classnames('types-slider', { 'types-slider--active': isActive })}
      ref={typesSliderRef}
    >
      <Slider ref={sliderRef} {...settings}>
        {slides.map((item, index, items) => {
          const isLastSlide = index + 1 === items?.length;
          const nextSlide = items[index + 1] || {};

          return (
            <TypesSlide
              {...item}
              handleCloseArticle={handleCloseArticle}
              handleNextArticle={handleNextArticle}
              handleNextSection={handleNextSection}
              handleToggle={handleToggle}
              index={index}
              isLastSlide={isLastSlide}
              nextArticle={nextArticle}
              nextSlide={nextSlide}
              id={`${Utils.slugify(title)}-${index}`}
              isVisible={currentSlide === index && isActive}
              key={index}
            />
          );
        })}
      </Slider>
    </div>
  );
};

TypesSlider.propTypes = {
  isActive: PropTypes.bool,
  image: PropTypes.string,
  items: PropTypes.array,
  nextArticle: PropTypes.object,
  title: PropTypes.string,
};

export default TypesSlider;
